import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxMdModule } from 'ngx-md';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { TypeaheadModule } from 'ngx-type-ahead';
import { AuthGuard } from '../shared/auth.guard';
import { SharedModule } from '../shared/shared.module';
import { QuestionFormComponent } from './question-form/question-form.component';
import { QuestionHelpComponent } from './question-help/question-help.component';
import { QuestionTreeComponent } from './question-tree/question-tree.component';
import { ValidationGuideComponent } from './validation.guide/validation.guide.component';

const routes: Routes = [
  {
    path: '',
    data: { title: 'Questions' },
    children: [
      { path: '', redirectTo: 'tree/', pathMatch: 'full' },
      { path: 'help', canActivate: [AuthGuard], component: QuestionHelpComponent, data: { title: 'Question Help' } },
      { path: 'tree', redirectTo: 'tree/' },
      {
        path: 'tree/:id',
        canActivate: [AuthGuard],
        component: QuestionTreeComponent,
        data: { title: 'Question Tree' },
      },
    ],
  },
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    PerfectScrollbarModule,
    NgxMdModule.forRoot(),
    EditorModule,
    TypeaheadModule,
  ],
  declarations: [QuestionFormComponent, QuestionTreeComponent, QuestionHelpComponent, ValidationGuideComponent],
  exports: [RouterModule],
})
export class QuestionModule {}
